<template>
  <div class="homeBox">
    <div class="homeBox-t">
      <div class="homeBox-t-l">
        <div class="title1">
          <div></div>
          <div>
            已接入项目：
          </div>
          <div>
            {{projects.length}}个
          </div>
        </div>
        <div class="cont11">
          <div class="cont1" :class="{scroll1:lock==true}">
          <div class="item" v-for="item in projectsLL">
            <img src="../../assets/image/new/多边形19.png" alt="">
            <div :title="item.name">
              {{item.name}}
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="homeBox-t-m">
        <baidu-map
            :center="center"
            id="xjMap"
            :zoom="zoom"
            @ready="handler"
            style="height:100%;width:100%;"
            @click="getClickInfo"
            :scroll-wheel-zoom="true"
        >                                                                                                     
            <bm-marker v-for="item in points" @click="clickHandler(item)" :key="item.id" :position="item.position" :imageURL="item.url" :icon="{url: item.url, size: {width: item.width, height: item.height}}">
            </bm-marker>
        </baidu-map>
      </div>
      <div class="homeBox-t-b">
        <div class="title1">
          <div></div>
          <div class="title1-r">
            <div>识别记录</div>
            <div>
              <el-select @change="getData" class="xiala" v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in projects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="table-title">
          <el-row style="height:100%">
            <el-col style="height:100%" :span="4"><div class="title-text">姓名</div></el-col>
            <el-col style="height:100%" :span="7"><div class="title-text">健康码</div></el-col>
            <el-col style="height:100%" :span="6"><div class="title-text">核酸状态</div></el-col>
            <el-col style="height:100%" :span="7"><div class="title-text">时间</div></el-col>
          </el-row>
        </div>
        <div class="cont22">
          <div class="cont2" :class="{scroll2:lock2==true}">
            <el-row style="height:1.6667vw;margin-bottom: 0.3646vw;" v-for="item in tableList">
              <el-col style="height:100%;" :span="4"><div class="item-text">{{item.name}}</div></el-col>
              <el-col style="height:100%;" :span="7">
                <div class="item-ewm">
                  <img :src="item.codeImg" style="height: 1.5625vw" />
                </div>
              </el-col>
              <el-col style="height:100%;" :span="6">
                <div class="item-zt">
                  <div v-if="item.signName == '阴性'" style="display:flex;">
                    <img style="width: 1vw;margin-right:4px" src="../../assets/image/newAnKang/yin11.png">
                    <p style="font-size:0.5vw;color: #23d715;">已过{{item.timeSpan}}天</p>
                  </div>
                  <div v-else-if="item.signName == '阳性'" style="display:flex;">
                    <img style="width: 1vw;margin-right:4px" src="../../assets/image/newAnKang/yang.png">
                    <p style="font-size:0.5vw;color: #E32932;">已过{{item.timeSpan}}天</p>
                  </div>
                  <div v-else>
                    <p style="font-size:0.5vw;color: #bebebe;">暂无核酸</p>
                  </div>
                </div>
              </el-col>
              <el-col style="height:100%;" :span="7"><div class="item-date">{{item.date}}</div></el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="homeBox-b">
      <div class="homeBox-b-l">
        <div class="title1">
          <div></div>
          <div class="title1-r" style="width:63%">
            <div>日通行人员核酸状态</div>
            <div></div>
            <div>
              <el-date-picker
              @change="timeChange1"
                style="width:14vw"
                size="small"
                v-model="value1"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="box1-l-cont" id="chart1"></div>
        <div class="tip1">
          <div
            style="width: 1.5625vw;
            height: .1042vw;
            background: #0B62F0;"></div>
            正常
        </div>
        <div class="tip2">
          <div 
            style="width: 1.5625vw;
            height: .1042vw;
            background: #F00B0B;"></div>
            异常
        </div>
      </div>
      <div class="homeBox-b-b">
        <div class="title1">
          <div></div>
          <div class="title1-r" style="width:63%">
            <div>日通行人员健康码状态</div>
            <div></div>
            <div>
              <el-date-picker
                style="width:14vw"
                size="small"
                :clearable="false"
                @change="timeChange2"
                v-model="value2"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="box1-l-cont" id="chart2"></div>
        <div class="tip1">
          <div></div>
            绿码
        </div>
        <div class="tip2">
          <div></div>
            黄码
        </div>
        <div class="tip3">
          <div></div>
            红码
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
  export default {
    data() {
      return {
        points:[],
        center: {
          lng: 117.129186,
          lat: 31.836603
        },
        zoom: 13,
        groupId:'',
        value:'',
        value1:[util.myTime.timeBefore(new Date(),7),util.myTime.getCurTime()],
        value2:[util.myTime.timeBefore(new Date(),7),util.myTime.getCurTime()],
        options:[
          {
            label:'包河区中铁中小学项目',
            value:'1'
          }
        ],
        list1: [111,222,333,444,555,666,777,888,999,'10210102102102102102102102102110210102102102102102102102102101201201020102100120120120102010210012'],
        lock:false, // 已接项目动画锁
        lock2:false, // 已接项目动画锁
        time1:null, //已接项目间隔触发定时器
        time11:null, //已接项目动画单次触发定时器
        time2:null, //已接项目间隔触发定时器
        time22:null, //已接项目动画单次触发定时器
        time3:null,
        projects:[], // 项目列表
        projectsLL:[], // 项目列表（动画）
        tableList:[],
        attendType:[],
        indexAA:0
      }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.findEntStrangerDayHealthAndNucleicAcidStatistics1()
      this.findEntStrangerDayHealthAndNucleicAcidStatistics2()
      if(this.time1!=null){
        clearInterval(this.time1)
        this.time1 = null
      }
      if(this.time11!=null){
        clearTimeout(this.time11)
        this.time11=null
      }
      if(this.time3!=null){
        clearTimeout(this.time3)
        this.time3=null
      }
    },
    beforeDestroy(){
      if(this.time1!=null){
        clearInterval(this.time1)
        this.time1 = null
      }
      if(this.time11!=null){
        clearTimeout(this.time11)
        this.time11=null
      }
      if(this.time2!=null){
        clearInterval(this.time2)
        this.time2 = null
      }
      if(this.time22!=null){
        clearTimeout(this.time22)
        this.time22=null
      }
      if(this.time3!=null){
        clearTimeout(this.time3)
        this.time3=null
      }
    },
    methods:{
       //关闭
    infoWindowClose(){
        this.curIndex = undefined
    },
      getClickInfo(e) {
      // console.log(e)
        if(!this.curIndex){
            var allOverlay = this.map.getOverlays();
            for(var i=0;i<allOverlay.length;i++){
                if(allOverlay[i].toString()=="[object Overlay]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
        }
        this.infoWindowClose()
    },
      //展示地图数据
    showMapMarker(obj){
        var _selt = this
        // 复杂的自定义覆盖物
        function ComplexCustomOverlay(point,obj){
            this._point = point;
            this._option = obj
        }
        ComplexCustomOverlay.prototype = new BMap.Overlay();
        ComplexCustomOverlay.prototype.initialize = function(map){
            this._map = map;
            var option = this._option;
            var div = this._div = document.createElement("div");
            div.style.position = "absolute";
            // div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
            div.style.zIndex = 500;
            div.style.height = "300px";
            div.style.width = "240px";
            div.style.background = "rgba(19, 46, 140, 0.8)";
            div.style.borderRadius = "5px";
            div.style.padding = "10px";
            div.style.cursor = 'pointer'
            var that = this;

            //图片
            var imgDiv = document.createElement("img");
            imgDiv.style.position = "relative";
            imgDiv.style.width = "220px";
            imgDiv.style.height = "150px";
            imgDiv.style.marginBottom = "20px";
            var imgs = option.photoPath.split(',')
            var img = ''
            for(var i=0;i<imgs.length;i++){
                if(imgs[i]!=''){
                    img = base.httpCtx+imgs[i]
                }
            }
            if(img==''){
                imgDiv.src = require('../../assets/image/zanwutupian.png')
            }else{
                imgDiv.src = img
            }
            div.appendChild(imgDiv);

            //项目名称
            var nameText = document.createElement("p");
            nameText.style.position = "relative";
            nameText.style.width = "100%";
            nameText.style.height = "30px";
            nameText.style.fontSize = "14px";
            nameText.style.color = "rgba(255, 255, 255, 1)";
            nameText.style.whiteSpace = "nowrap";
            nameText.style.textOverflow = "ellipsis";
            nameText.style.overflow = "hidden";
            nameText.innerHTML = option.name||'';
            nameText.title = option.name||'';
            div.appendChild(nameText);

            //项目位置
            var addrText = document.createElement("p");
            addrText.style.position = "relative";
            addrText.style.width = "100%";
            addrText.style.height = "30px";
            addrText.style.fontSize = "12px";
            addrText.style.color = "rgba(255, 255, 255, 1)";
            addrText.style.whiteSpace = "nowrap";
            addrText.style.textOverflow = "ellipsis";
            addrText.style.overflow = "hidden";
            addrText.title = option.address||'';
            addrText.innerHTML = '项目位置：'+option.address;
            div.appendChild(addrText);

            //投资进度
            // var progressText = document.createElement("p");
            // progressText.style.position = "relative";
            // progressText.style.width = "100%";
            // progressText.style.height = "30px";
            // progressText.style.fontSize = "12px";
            // progressText.style.color = "rgba(255, 255, 255, 1)";
            // progressText.innerHTML = '投资进度：'+(option.cumulativeComplete||0)+'%'+', 金额：'+(option.price||0)+'万';
            // div.appendChild(progressText);

            //工期
            var dateText = document.createElement("p");
            dateText.style.position = "relative";
            dateText.style.width = "100%";
            dateText.style.height = "30px";
            dateText.style.fontSize = "12px";
            dateText.style.color = "rgba(255, 255, 255, 1)";
            dateText.innerHTML = '工期：'+option.allDay+'天, 剩余：'+option.otherDay+'天（'+option.progress+'%）';
            div.appendChild(dateText);

            div.onclick = function(){
                // util.session.set('proId', option.id)
                // util.session.set('backPage', '4')
                // //var that = this
                // setTimeout(function() {
                //     _selt.$router.push({ path: '/attendTeamCom' })
                // }, 0)
            }

            map.getPanes().labelPane.appendChild(div);
            
            return div;
        }
        ComplexCustomOverlay.prototype.draw = function(){
            var map = this._map;
            var pixel = map.pointToOverlayPixel(this._point);
            this._div.style.left = (pixel.x + 20) + 'px' ;
            this._div.style.top  = pixel.y  + 'px' ;
        }
        var allOverlay = this.map.getOverlays();
        for(var i=0;i<allOverlay.length;i++){
            if(allOverlay[i].toString()=="[object Overlay]"){
                this.map.removeOverlay(allOverlay[i]);
            }
        }
        var gpsLi = obj.gpsPoint.split(",");
        var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi[0], gpsLi[1]),obj);
        this.map.addOverlay(myCompOverlay);
        
    },
      //点击方法
    clickHandler(e){
        this.curIndex = e
        this.showMapMarker(e)
    },
      //展示地图标记
    showMarker(list){
        var points = [];
        var viewPoints = []
        for (var i = 0; i < list.length; i++) {
            if(list[i].gpsPoint&&''!=list[i].gpsPoint){
                var obj = list[i]
                var position = list[i].gpsPoint.split(',')
                obj.position = {lng: position[0], lat: position[1]}
                obj.typeName = list[i].projectType=='1'?'房建':'市政'
                
                if(list[i].allDay){
                    var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay) 
                    obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
                }else{
                    obj.progress = 0
                }

                if(obj.projectStatus=='2'){
                  obj.url = require('../../assets/image/pro_build.gif')
                  obj.width = 60,
                  obj.height = 60
                }else if(obj.projectStatus=='3'){
                  obj.url = require('../../assets/image/pro_build.gif')
                  obj.width = 60,
                  obj.height = 60
                }else if(obj.projectStatus=='4'){
                  obj.url = require('../../assets/image/pro_build.gif')
                  obj.width = 60,
                  obj.height = 60
                }
                points.push(obj)
                viewPoints.push(new BMap.Point(obj.position.lng,obj.position.lat))
            }
            console.log(points)
        }
        // console.log(points)
        // this.center = points.length>0?points[0].position:this.center
        this.points = points
        //设置地图视野zoon和中心点
        var view = this.map.getViewport(eval(viewPoints));
        
        if(this.groupId !='1263382107619520513'){
          // this.zoom = 5
          this.center = view.center
          var that = this
          setTimeout(function(){
            that.map.setViewport(viewPoints)
          },100)
        }
        setTimeout(function(){
          var pointBg = document.getElementsByClassName('BMap_Marker')
          for(var i=0;i<pointBg.length;i++){
            if(pointBg[i].className=='BMap_Marker'){
              pointBg[i].parentNode.style.zIndex = 500
            }
          }
        },1000)
    },
      //地图展示
    handler({ BMap, map }) {
        this.map = map
        this.getAll()
        // var cityName = '安徽省';
        // map.centerAndZoom(cityName, 11);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
        map.enableScrollWheelZoom();
        // var bdary = new BMap.Boundary();
        // marker.Yc.parentNode.parentNode.style.zIndex = 500;
        var styleJson = [{
            "featureType": "land",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "green",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "building",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "building",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "building",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "subwaystation",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "education",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "medical",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "scenicspots",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "color": "#ffffff"
            }
        }, {
            "featureType": "highway",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "weight": 4
            }
        }, {
            "featureType": "highway",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "highway",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "highway",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "highway",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "highway",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "highway",
            "elementType": "labels.icon",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "arterial",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "weight": 2
            }
        }, {
            "featureType": "arterial",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "arterial",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "arterial",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "arterial",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffff"
            }
        }, {
            "featureType": "arterial",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "local",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "weight": 1
            }
        }, {
            "featureType": "local",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "local",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "local",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "local",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "local",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "railway",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "weight": 1
            }
        }, {
            "featureType": "railway",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "railway",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "subway",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on",
                "weight": 1
            }
        }, {
            "featureType": "subway",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "subway",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "subway",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "subway",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "subway",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "continent",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "continent",
            "elementType": "labels.icon",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "continent",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "continent",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "city",
            "elementType": "labels.icon",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "city",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "city",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "city",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "town",
            "elementType": "labels.icon",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "town",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "town",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "town",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": {
                "color": "#ffffffff " //  #12223dff
            }
        }, {
            "featureType": "poilabel",
            "elementType": "labels",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "districtlabel",
            "elementType": "labels",
            "stylers": {
                "visibility": "off"
            }
        }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": {
                "visibility": "on"
            }
        }, {
            "featureType": "road",
            "elementType": "labels",
            "stylers": {
                "visibility": "off"
            }
        }, {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "district",
            "elementType": "labels",
            "stylers": {
                "visibility": "off"
            }
        }, {
            "featureType": "poilabel",
            "elementType": "labels.icon",
            "stylers": {
                "visibility": "off"
            }
        }, {
            "featureType": "poilabel",
            "elementType": "labels.text.fill",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "poilabel",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "manmade",
            "elementType": "geometry",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "districtlabel",
            "elementType": "labels.text.stroke",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "entertainment",
            "elementType": "geometry",
            "stylers": {
                "color": "#ffffffff"
            }
        }, {
            "featureType": "shopping",
            "elementType": "geometry",
            "stylers": {
                "color": "#ffffffff"
            }
        }];
        var that = this
        setTimeout(function(){
          if(util.session.get('groupId') =='1263382107619520513'){
            map.setMapStyle({styleJson:styleJson});
          }
        },500)
    },
        echarts1(name,hao,huai){
          this.$echarts.init(document.querySelector('#chart1')).dispose();
          let chart1 = this.$echarts.init(document.querySelector('#chart1'))
          chart1.setOption({
            tooltip: {
            trigger: 'axis',
            textStyle:{

              align:'left'
            }
          },
            grid: {
            left: '5%', // 可以决定图形画布距离左侧的位置
            right: '5%', // 可以决定图形画布距离右侧的位置
            bottom: '0%',
            top:'9%',
            containLabel: true
          },
          width:'85%',
            title:{
              left:'10%',
              top:'0%',
              text:'单位/人次',
              textStyle:{
                  //文字颜色
                  color:'#666666',
                  //字体风格,'normal','italic','oblique'
                  fontStyle:'normal',
                  //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                  fontWeight:'normal',
                  //字体大小
          　　　　 fontSize:12
              }
            },
            xAxis: {
              axisLabel:{
                color:'#666666'
              },
              axisTick:{
                lineStyle:{
                  color:'#fff'
                }
              },
              axisLine:{
                show: true,    // 是否显示坐标轴轴线
                lineStyle:{
                  type:'solid',
                  color:'#0353F4'
                }
              },
              splitLine:{
                show: true, //让网格显示
                lineStyle: {//网格样式
                color:['#4D6EB1'], //网格的颜色
                width:1, //网格的宽度
                type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
              }
                        },
              type: 'category',
              boundaryGap: false,
              data: name
            },
            yAxis: {
              axisLabel:{
                color:'#666666'
              },
              axisTick:{
                lineStyle:{
                  color:'#fff'
                }
              },
              axisLine:{
                show: true,    // 是否显示坐标轴轴线
                  symbol: ['none', 'arrow'],     // 轴线两端箭头，两个值，none表示没有箭头，arrow表示有箭头
                  symbolSize: [10, 15],
                lineStyle:{
                  type:'solid',
                  color:'#0353F4'
                }
              },
              splitLine:{
                show: true,
                lineStyle: {
                  color:['#4D6EB1'],
                  width:1,
                  type:'dashed'
                }
              },
              type: 'value'
            },
            color:['#9EC7F5','#F00B0B'],
            series: [
              {
                data: hao,
                type: 'line',
                areaStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        { offset: 0, color: '#9EC7F5' }, 
                        { offset: 1, color: '#fff' }
                      ]
                    )
                  }
                }
              },
              {
                data: huai,
                type: 'line',
                areaStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        { offset: 0, color: '#F00B0B' }, 
                        { offset: 1, color: '#fff' }
                      ]
                    )
                  }
                }
              }
            ]
          })
          window.addEventListener("resize", () => {
            // 自动渲染echarts
            chart1.resize();
          });
      },
      findEntStrangerDayHealthAndNucleicAcidStatistics1(){
        myHttp.findEntStrangerDayHealthAndNucleicAcidStatistics({
          entId:util.session.get('groupId'),
          startTime:this.value1[0],
          endTime:this.value1[1]
        }).then(res=>{
          console.log(res,'360')
          if(res.data.code == 200){
            let list = res.data.data.entStrangerDayHealthAndNucleicAcidStatistics||[]
            let nameList = []
            let hao = []
            let huai = []
            list.forEach(item=>{
              nameList.push(item.time)
              hao.push(item.nucleicAcidNormalCount)
              huai.push(item.nucleicAcidAbnormalCount)
            })
            this.echarts1(nameList,hao,huai)
          }
        })
      },
      timeChange1(){  
        if(this.value1==null){
          this.value1 = ['','']
        }else{
          if(util.myTime.getdayByDate(this.value1[0],this.value1[1])>6){
            this.$message.error('最大间隔时间为7天！')
          }else{
            this.findEntStrangerDayHealthAndNucleicAcidStatistics1()
          }
        }
        console.log(this.value1)
      },
      echarts2(name,lv,huang,hong){
        this.$echarts.init(document.querySelector('#chart2')).dispose();
        let chart2 = this.$echarts.init(document.querySelector('#chart2'))
        chart2.setOption({
          title:{
            left:'10%',
            top:'0%',
            text:'单位/人次',
            textStyle:{
                //文字颜色
                color:'#666666',
                //字体风格,'normal','italic','oblique'
                fontStyle:'normal',
                //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                fontWeight:'normal',
                //字体大小
        　　　　 fontSize:12
            }
          },
          grid: {
            left: '5%', // 可以决定图形画布距离左侧的位置
            right: '5%', // 可以决定图形画布距离右侧的位置
            bottom: '0%',
            top:'9%',
            containLabel: true
          },
          width:'85%',
            xAxis: {
              axisLine:{
                show: true,    // 是否显示坐标轴轴线
                lineStyle:{
                  type:'solid',
                  color:'#0353F4'
                }
              },
              splitLine:{
                show: true, //让网格显示
                lineStyle: {//网格样式
                color:['#4D6EB1'], //网格的颜色
                width:1, //网格的宽度
                type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                }
              },
              axisLabel:{
                color:'#666666'
              },
              axisTick:{
                lineStyle:{
                  color:'#fff'
                }
              },
              type: 'category',
              data: name
            },
            yAxis: {
              axisLabel:{
                color:'#666666'
              },
              axisTick:{
                lineStyle:{
                  color:'#fff'
                }
              },
              minInterval:1,
              type: 'value',
              axisLine:{
                show: true,    // 是否显示坐标轴轴线
                symbol: ['none', 'arrow'],     // 轴线两端箭头，两个值，none表示没有箭头，arrow表示有箭头
                symbolSize: [10, 15],
                lineStyle:{
                  type:'solid',
                  color:'#0353F4'
                }
              },
              splitLine:{
                    show: true,
                    lineStyle: {
                      color:['#4D6EB1'],
                      width:1,
                      type:'dashed'
                    }
                },
            },
            color:['#1CBC10','#E98305','#FF3E00'],
            series: [
              {
                data: lv,
                type: 'bar',
                itemStyle:{
                  normal:{
                    label:{
                      formatter:function(val){
                        if(true){
                          return `${val.value}`
                        }
                      },
                    show:true,
                    position:'top',
                    textStyle:{
                      fontWeight:"bolder",
                      fontSize:"12",
                      color:"#1CBC10"
                    }
                    }
                  }
                }
              },
              {
                data: huang,
                type: 'bar',
                itemStyle:{
                  normal:{
                    label:{
                      formatter:function(val){
                        if(true){
                          return `${val.value}`
                        }
                      },
                    show:true,
                    position:'top',
                    textStyle:{
                      fontWeight:"bolder",
                      fontSize:"12",
                      color:"#FF3E00"
                    }
                    }
                  }
                }
              },
              {
                data: hong,
                type: 'bar',
                itemStyle:{
                  normal:{
                    label:{
                      formatter:function(val){
                        if(true){
                          return `${val.value}`
                        }
                      },
                    show:true,
                    position:'top',
                    textStyle:{
                      fontWeight:"bolder",
                      fontSize:"12",
                      color:"#D00810"
                    }
                    }
                  }
                }
              }
            ]
        })
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          chart2.resize();
        });
      },
      findEntStrangerDayHealthAndNucleicAcidStatistics2(){
        myHttp.findEntStrangerDayHealthAndNucleicAcidStatistics({
          entId:util.session.get('groupId'),
          startTime:this.value2[0],
          endTime:this.value2[1]
        }).then(res=>{
          console.log(res,'553')
          if(res.data.code == 200){
            let list = res.data.data.entStrangerDayHealthAndNucleicAcidStatistics||[]
            let nameList = []
            let lv = []
            let huang = []
            let hong = []
            list.forEach(item=>{
              nameList.push(item.time)
              lv.push(item.greenCount)
              huang.push(item.yellowCount)
              hong.push(item.redCount)
            })
            this.echarts2(nameList,lv,huang,hong)
          }
        })
      },
      timeChange2(){  
        if(this.value2==null){
          this.value2 = ['','']
        }else{
          if(util.myTime.getdayByDate(this.value2[0],this.value2[1])>6){
            this.$message.error('最大间隔时间为7天！')
          }else{
            this.findEntStrangerDayHealthAndNucleicAcidStatistics2()
          }
        }
        console.log(this.value2)
      },
      //触发已接项目间隔触发定时器
      bbb(){
        let that = this
        that.time2 = setInterval(() => {
          that.lock2=true
          that.scroll2()
        }, 2500);
      },
      // 已接项目单次动画
      scroll2(){
        let that = this
         that.time22 =  setTimeout(()=>{
          that.tableList.push(this.tableList[0])
          that.tableList.shift()
          that.lock2=false
          if(that.time22!=null){
            clearTimeout(that.time22)
            that.time22=null
          }
        },2000)
      },
      getDict() {
        var that = this
        myHttp.getDictByType({
          type: 'attend_type'
        }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList||[]
            for(var i=0;i<list.length;i++){
              list[i].text = list[i].label
            
            }
            that.attendType = list
            that.getData()
            that.time3 = setInterval(() => {
              that.indexAA++
              if(that.indexAA>that.projects.length-1){
                that.indexAA=0
              }
              that.value=that.projects[that.indexAA].id
              that.getData()
            }, 30000);
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
        //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
      getData(){
        let that = this
        myHttp.findStrangerInOutPage({
          projectId:this.value,
          pageSize:30,
          pageNum:1,
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            if(that.time2!=null){
                clearInterval(that.time2)
                that.time2 = null
              }
              if(that.time22!=null){
                clearTimeout(that.time22)
                that.time22=null
              }
            let list = res.data.data.strangerInOutPage.list
            that.total = res.data.data.strangerInOutPage.total
            for (var i = 0; i < list.length; i++) {
              list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
              list[i].typeName = that.filterSatus(list[i].status)
              if (list[i].healthLevel == '1') {
                list[i].codeImg = require('../../assets/image/new/green.png')
              } else if (list[i].healthLevel == '2') {
                list[i].codeImg = require('../../assets/image/new/yellow.png')
              } else if (list[i].healthLevel == '3') {
                list[i].codeImg = require('../../assets/image/new/red.png')
              } else if (
                list[i].healthLevel == '4' ||
                list[i].healthLevel == '0'
              ) {
                list[i].codeImg = require('../../assets/image/new/no.png')
              }
              
              // list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:''
              // list[i].createDate = list[i].createDate && list[i].createDate!=''?list[i].createDate.split(' ')[0]:''
              // list[i].age = util.myTime.getAge(list[i].birthday)
            }
            that.tableList = list
            if(that.projects.length>8){
              that.bbb()
            }
          }
        })
      },
      //获取所有项目
      getAll() {
        var that = this
        myHttp.getProjectListByEntIdAndJoinType({
          entId: this.groupId,
          // joinType: this.search.joinType
        }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            that.projects = list
            let a = JSON.stringify(list)
            that.projectsLL = JSON.parse(a)
            if(that.projects.length!=0){
              that.value = that.projects[0].id
              that.getDict()
              that.showMarker(that.projects)
            }
            console.log(that.projects)
            if(that.projectsLL.length>7){
              that.aaa()
            }
          }
        })
      },
      //触发已接项目间隔触发定时器
      aaa(){
        let that = this
        that.time1 = setInterval(() => {
          that.lock=true
          that.scroll1()
        }, 2500);
      },
      // 已接项目单次动画
      scroll1(){
        let that = this
         that.time11 =  setTimeout(()=>{
          that.projectsLL.push(this.projectsLL[0])
          that.projectsLL.shift()
          that.lock=false
          if(that.time11!=null){
            clearTimeout(that.time11)
            that.time11=null
          }
        },2000)
      },
    }
  }
</script>

<style scoped>
.homeBox{
  width: 100%;
  height: 100%;
  padding: .8333vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.homeBox-t{
  height: 53.4%;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.homeBox-b{
  height: 44.53%;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.homeBox-t-l{
  padding: .8854vw .3125vw .625vw .3125vw;
  height: 100%;
  width: 30.2%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: .3125vw;
}
.homeBox-t-m{
  padding: .8333vw;
  height: 100%;
  width: 37.9%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: .3125vw;
}
.homeBox-t-b{
  padding: .8854vw .3125vw .625vw .3125vw;
  height: 100%;
  width: 30.2%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: .3125vw;
}
.homeBox-b-l{
  position: relative;
  padding: .8333vw;
  height: 100%;
  width: 49.58%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: .3125vw;
}
.homeBox-b-b{
  position: relative;
  padding: .8333vw;
  height: 100%;
  width: 49.58%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: .3125vw;
}
.title1{
  height: 1.1458vw;;
  display: flex;
  justify-content: start;
  align-items: center;
}
.title1>div:nth-child(1){
  margin-left: .4167vw;
  height: 100%;
  width: .2083vw;
  background-color: #358ADA;
}
.title1>div:nth-child(2){
  font-size: .7292vw;
  color: #666666;
  margin-left: .4167vw;
  font-family: PingFangSC-Regular;
}
.title1>div:nth-child(3){
  font-size: .7292vw;
  color: #34C414;
  font-family: PingFangSC-Regular;
}
.cont11{
  overflow: hidden !important;
  margin-top: .6771vw;
  height: 90%;
}
.cont1{
  margin-top:0;
  width: 100%;
  height: 100%;
}
.cont1::-webkit-scrollbar{
  width: 0;
}
.cont1>.item{
  height: 2.117vw;
  width: 100%;
  margin-bottom: .4167vw;
  border: 1px solid #EDF5FF;
  background: #F1F8FF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: start;
}
.scroll1{
  transition: all 2s;
  margin-top: -2.5337vw !important;
}
.scroll2{
  transition: all 2s;
  margin-top: -2.0313vw !important;
}
.cont1>.item>img{
  width: .9375vw;
  height: .7292vw;
  margin-left: .625vw;
  margin-right: .4167vw;
}
.cont1>.item>div{
  text-align: start;
  color: #333333;
  font-size: .8333vw;
  width: 91%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  font-family: MicrosoftYaHei;
}
.title1-r{
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-between;
  width: 90%;
}
.title1-r>div:nth-child(1){
  font-family: PingFangSC-Regular;
  font-size: .8333vw;
  color: #666666;
}
::v-deep .xiala .el-input__inner{
  border: none;
  text-align: end;
  font-family: MicrosoftYaHei;
  font-size: .8333vw;
  color: #358ADA;
}
.table-title{
  height:1.5625vw ;
  width: 29.0625vw;
  border-radius: .2083vw;
background: #F1F8FF;
box-sizing: border-box;
border: 1px solid #EDF5FF;
margin-top: 11px;
}
.cont22{
  height: 81.3%;
  margin-top: .3125vw;
  overflow: hidden;
}
.cont2{
  margin-top: 0;
  height: 100%;
}
.title-text{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
font-size: .8333vw;
color: #666666;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
}
.item-text{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
font-size: .8333vw;
font-weight: normal;
letter-spacing: 0em;

color: #999999;
}
.item-ewm{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-zt{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-date{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MicrosoftYaHei;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;
color: #999999;
}
.box1-l-cont{
  height: 14.7vw;
}
.tip1{
  position:absolute;
  right: 2%;
  top: 20%;
  color: #666666;
  font-size: .7292vw;
  display: flex;
  align-items: center;
}
.tip1>div{
  width: 1.0417vw;
  height: 1.0417vw;
  background: #1CBC10;
  margin-right: .5208vw;
}
.tip2>div{
  width: 1.0417vw;
  height: 1.0417vw;
  background: #E98305;
  margin-right: .5208vw;
}
.tip2{
  position:absolute;
  right: 2%;
  top: 30%;
  color: #666666;
  font-size: .7292vw;
  display: flex;
  align-items: center;
}
.tip3>div{
  width: 1.0417vw;
  height: 1.0417vw;
  background: #FF3E00;
  margin-right: .5208vw;
}
.tip3{
  position:absolute;
  right: 2%;
  top: 40%;
  color: #666666;
  font-size: .7292vw;
  display: flex;
  align-items: center;
}
</style>